import { render, staticRenderFns } from "./dr-property-check-box.vue?vue&type=template&id=5331f5a8&scoped=true&"
import script from "./dr-property-check-box.vue?vue&type=script&lang=js&"
export * from "./dr-property-check-box.vue?vue&type=script&lang=js&"
import style0 from "./dr-property-check-box.vue?vue&type=style&index=0&id=5331f5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331f5a8",
  null
  
)

export default component.exports